/**
 * The four corner registration marks (`.gp-fd-tick` in tokens.css), drawn just
 * outside the parent's corners. Decoration only. The parent must be positioned.
 */
export function CornerTicks() {
  return (
    <>
      <span className="gp-fd-tick gp-fd-tick-tl" aria-hidden="true" />
      <span className="gp-fd-tick gp-fd-tick-tr" aria-hidden="true" />
      <span className="gp-fd-tick gp-fd-tick-bl" aria-hidden="true" />
      <span className="gp-fd-tick gp-fd-tick-br" aria-hidden="true" />
    </>
  );
}
